import { useEffect, useState } from 'react';
import axiosInstance from '../axios/axiosInstance';

function useProductHook(id) {
  const [produto, setProduto] = useState('');
  const [loading, setLoading] = useState(true);

  const getProdutos = async (id) => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(`produto/${id}/`);
      setProduto(res.data);
      setLoading(false);
    } catch (error) {
      if (error.code === 'ERR_NETWORK') {
        setLoading(false);
        return setProduto({ error: 'ERR_NETWORK' });
      }
      setLoading(false);
      return setProduto({ error: 'Não encontrado' });
    }
  };
  const resetProduto = () => {
    setProduto('');
  };

  useEffect(() => {
    if (id) {
      getProdutos(id);
    }
  }, [id]);

  return { produto, getProdutos, loading, resetProduto };
}

export default useProductHook;
